import { PocSwitch } from 'commons/components/components-wrapper/poc-switch.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { DeviceConfigStatusTrackingDescriptionCard } from '../status-tracking-row.style';
import {
    DeviceConfigStatusTrackingCardStyled,
    DeviceConfigStatusTrackingContainer,
    DeviceConfigStatusTrackingHeader,
} from './device-config-status-tracking-card.style';

interface DeviceConfigStatusTrackingCardProps {
    children?: React.ReactNode;
    title?: string;
    description?: string;
    toggleChecked?: boolean;
    className?: string;
    onToggleCheckedChange?: (value: boolean) => void;
}

export const DeviceConfigStatusTrackingCard = ({
    children,
    title,
    description,
    toggleChecked = false,
    className,
    onToggleCheckedChange,
}: DeviceConfigStatusTrackingCardProps) => (
    <DeviceConfigStatusTrackingCardStyled rounded className={className}>
        <DeviceConfigStatusTrackingHeader slot="header" style={{ borderBottom: 'none' }}>
            <PocTypography variant="title6" style={{ display: 'block' }}>
                {title}
            </PocTypography>
            <PocSwitch
                slot="suffix"
                value={title}
                aria-label={title}
                data-testid={`switch-${title}`}
                checked={toggleChecked}
                onValueChange={(e) => {
                    onToggleCheckedChange?.(e.detail);
                }}
            />
        </DeviceConfigStatusTrackingHeader>
        {description && (
            <DeviceConfigStatusTrackingDescriptionCard>{description}</DeviceConfigStatusTrackingDescriptionCard>
        )}
        <DeviceConfigStatusTrackingContainer className={`${toggleChecked ? '' : 'disabled'}`}>
            {children}
        </DeviceConfigStatusTrackingContainer>
    </DeviceConfigStatusTrackingCardStyled>
);
